import React, { useState, useEffect, useContext } from "react"

// Components
import { UserProfile } from "../../components"
import { MainHeader } from "./components"
import Navbar from "../../ui/Navbar/Navbar"

// Modules
import PropTypes from "prop-types"
import { useParams } from "react-router-dom"

// Views
// Context providers / Utils
import { AuthContext } from "../../Auth/Auth"
import useFieldName from "../../hooks/useFieldName"

// Styles
import "../../styles/chart.css"
import "./Main.css"

const Main = (props) => {
    const { children, name, navItem } = props
    let { id } = useParams()

    // const [openSidebar, setOpenSidebar] = useState(false)
    const [header, setHeader] = useState("")
    const { currentUser } = useContext(AuthContext)

    const fieldName = useFieldName()

    const getHeader = () => {
        switch (name) {
            case "general":
                setHeader("General Model")
                break
            case "weather":
                setHeader("Weather Model")
                break
            case "satellite":
                setHeader("Satellite Model")
                break
            case "planting_tool":
                setHeader("Planting Tool")
                break
            case "spraying_tool":
                setHeader("Spraying Tool")
                break
            case "harvesting_tool":
                setHeader("Harvesting Tool")
                break
            case "nitrogen_application_tool":
                setHeader("Nitrogen Application Tool")
                break
            default:
                setHeader("View")
                break
        }
    }

    // TODO refactor this
    useEffect(() => {
        if (currentUser !== null) {
            getHeader()
        }
    }, [currentUser, id, name])

    return (
        <>
            <div className="main">
                <div className="main__header__navbar">
                    <Navbar view={name} navItem={navItem} />
                </div>
                <div className="main__content">
                    <div className="main__container">
                        <div className="main__header">
                            <MainHeader header={header} fieldName={fieldName} />
                        </div>
                        <div className="main__content__user">
                            <UserProfile />
                        </div>
                        {children}
                        <div className="powered-by">
                            <a className="powered-by__tag" href="https://www.climate.ai" target="_blank">
                                <div>Powered by</div>
                                <img alt="ClimateAI logo" src="/Climate-AI-Color-Logo.png" />
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

Main.propTypes = {
    children: PropTypes.node,
}

export default Main
